<template>
  <mdb-container fluid v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}">
    <!--Section: Intro-->
    <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold;">
      <strong>Obras</strong>
    </h2>
    <!--Section: Main panel-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Section: Table-->
        <!--Top Table UI-->
        <div class="card card-cascade">
          <!--Card image-->
          <div
            class="price white-text rounded-top"
            v-bind:style="{padding: '1rem 2rem', textAlign: 'left', background: '#f6f6f6', fontFamily: 'OpenSans-Regular', fontSize: '16px', lineHeight: '1.38'}"
          >
            <div class="text-right"  style=" margin-top: -10px; margin-right: -20px; float: right;">
            </div>
          </div>
          <!--/Card image-->
          <div class="px-4">
            <div class="table-responsive">
              <mdb-datatable
                :data="data"
                :borderless="true"
                responsive
                :tfoot="false"
                :arrows="true"
                :display="10"
                searchPlaceholder="Buscar"
                noFoundMessage="No se encontraron registros de obras"
                showingText="Mostrando"
                class="table table-responsive"
                id="dataTableBuilder_obra"
              />
            </div>
            <!--Bottom Table UI-->
          </div>
        </div>
        <!--Section: Table-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Main panel-->
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbCardText,
  mdbSelect,
  mdbBtn,
  mdbDatePicker,
  mdbTooltip,
  mdbSimpleChart,
  mdbIcon,
  mdbBadge,
  mdbView,
  mdbLineChart,
  mdbCardHeader,
  mdbListGroup,
  mdbListGroupItem,
  mdbInput,
  mdbDatatable
} from "mdbvue";

export default {
  name: "Constructions2",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbCardText,
    mdbSelect,
    mdbBtn,
    mdbDatePicker,
    mdbTooltip,
    mdbSimpleChart,
    mdbIcon,
    mdbBadge,
    mdbView,
    mdbLineChart,
    mdbCardHeader,
    mdbListGroup,
    mdbListGroupItem,
    mdbInput,
    mdbDatatable
  },
  data(){
    return{
        constructionSelected: [],
        reactiveTable: false ,
        contractor:[],
        consstructionsStatus:["Activo", "Pediente", "Sin Trabajadores"],
        urlServer: Servers.serverApi,
        imgServer: Servers.serverImg,
        data: {
        columns: [
          {
            label: "",
            field: "checkbox"
          },
          {
            label: "Nombre de la obra",
            field: "name",
            sort: "asc"
          },
          {
            label: "Numero de Trabajadores",
            field: "workers",
            sort: "asc"
          },
          {
            label: "Estatus",
            field: "status",
            sort: "asc"
          }
        ],
        rows: []
      }
    };
  },
  methods:{  
    makeListOfConstructions() {
      let aux = this;
      aux.constructionSelected = [];
      var arr = Array.prototype.slice.call(
        document.getElementsByClassName("form-check-input")
      );
      arr.map(function(value, key) {
        if (value.checked) {
          aux.constructionSelected.push({
            uuid: value.dataset.uuid
          });
        }
      });
  },
    editConstruction(){
      let aux = this;
      aux.makeListOfConstructions();
      if (this.constructionSelected.length == 1) {
          this.constructionSelected.map(function(value, key) {
               window.location.href = "./createConstruction?token="+ value.uuid;
          });
      }
       else if (aux.constructionSelected.length == 0){
        aux.showMessageInfo("Es necesario seleccionar una obra para poder editar.");
      } else {
         aux.showMessageInfo("No se puede editar varias obras a la vez.");

      }
    },
  removeConstruction(){
      let aux = this;
      aux.makeListOfConstructions();
      if (aux.constructionSelected.length == 1) {
        aux.constructionSelected.map(function(value, key) {
         
            Swal.fire({
              title:
                "<span style='font-size: 16px; font-family: OpenSans-Regular;'>¿Seguro que deseas eliminar esta obra?</span>",
              html:
                "<span style='font-size: 12px'>El la obra se eliminará permanentemente. </span>",
              imageUrl: Servers.serverImg+"apps/myfrac/admin/assets/Delete_Icon.png",
              imageWidth: "22%",
              imageHeight: "auto",
              width: "30%",
              showCancelButton: true,
              confirmButtonText: "Eliminar",
              cancelButtonText: "Cancelar",
              reverseButtons: true,
              customClass: {
                confirmButton: "btn-modal-accept",
                cancelButton: "btn-modal-cancel"
              }
            }).then(result => {
              if (result.value) {
                Axios.delete(
                  aux.urlServer + "api/constructions/" + value.uuid,
                  {
                    responseType: "application/json",
                    headers: {
                      Authorization:
                        "Bearer " + localStorage.getItem("access_token")
                    }
                  }
                ).then(
                  function(response) {
                    aux.showMessageSucces("Obra eliminada correctamente");
                  },
                  function(error) {
                    aux.showMessageError("Ha ocurrido un error", error.response.data);
                    return false;
                  }
                );
              }
            });
        });
      }
      else if (aux.constructionSelected.length == 0){
        aux.showMessageInfo("Es necesario seleccionar una obra para darla de baja.");
      } else {
         aux.showMessageInfo("No es posible eliminar más de una obra.");

      }
    

  },
    getConstuctions(uuid){
      let aux = this;
      Axios.get(Servers.serverApi + "api/constructions/contractor/?contractor="+uuid, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          response.data.map(function(value, key) {
          var object = {
              checkbox: '<input class="form-check-input" type="checkbox" id="constuction_' +
                value.uuid +
                '" data-uuid=' +
                value.uuid +
                '><label for="constuction_' +
                value.uuid +
                '" class="label-table"></label>',
              name: value.name,
              workers: value.workerCount > 0? '<div class="tooltip-p"><a href="./workers?construction='+value.uuid+'" style=" color: cornflowerblue; text-decoration: underline;">'+value.workerCount+'</a><span class="tooltiptext">Ver trabajadores</span></div>' :'<div class="tooltip-p"><a href="./createWorker?construction='+value.uuid+'"><img class="mt-0" src="https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Crear_BTN@3x.png" style="margin-left: 1rem; width: 31.2px; height: 31.2px; object-fit: contain;" /></a><span class="tooltiptext">Alta Trabajadores</span></div>',
              status: aux.getWorkersByConstruction(value.uuid, key)
            }
            aux.data.rows.push(object);
          });
        })
        .catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    showMessageError: function(text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: Servers.serverImg+"apps/myfrac/admin/assets/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function(text) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>Correcto</span>",
        html: "<span style='font-size: 12px;'>" + text + "</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () =>{
          window.location.reload();
        }
      });
    },
    getOneContractor(){
      let aux = this;
      Axios.get(Servers.serverApi + "api/contractors/user", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
    }).then(function (response){
      localStorage.setItem("uuid", response.data.uuid);
      aux.contractor = response.data;
       aux.getConstuctions(response.data.uuid);
      


    }).catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    getWorkersByConstruction(uuid, key) {
      let aux = this;
      Axios.get(
        Servers.serverApi +
          "api/constructionWorkers/construction?construction=" +
          uuid,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      )
        .then(function(response) {
          var workerList = response.data;
          var statusConstruction="Aprobado"
          var statusReason;

          workerList.map(function(value, key_2) {
            if(value.status!="Aprobado"){
              if(value.status=="Rechazado"){
                statusConstruction = "Rechazado";
                statusReason = "El trabajador "+value.firstName+" "+value.lastName+" fue rechazado";
              }
              else{
                statusConstruction = "Pendiente"
              }
            }
      });

      if(statusConstruction == "Aprobado"){
        aux.$set(
            aux.data.rows[key],
            "status",
            '<div><span> Solicitud aprobada</span></div>'
          );
          return;

      }
      if(statusConstruction == "Rechazado"){
        aux.$set(
            aux.data.rows[key],
            "status",
            '<div class="tooltip-p"> Solicitud rechazada <span class="badge badge-pill badge-danger" style="position: absolute; margin-top: -10px;"><i class="fas fa-exclamation-circle"></i></span><span class="tooltiptext" style="width: 200px !important">'+statusReason+'</span></div>'
          );
          return;

      }
      if(statusConstruction == "Pendiente"){
         aux.$set(
            aux.data.rows[key],
            "status",
            '<div class="tooltip-p"> Solicitud pendiente <span class="badge badge-pill badge-info" style="position: absolute; margin-top: -10px;"><i class="fas fa-exclamation-circle"></i></span><span class="tooltiptext" style="width: 200px !important">La solicitud de trabajadores ha sido enviada al administrador</span></div>'
          );
          return;

      }
        }, function(error){
           this.$set(
            this.data.rows[key],
            "status",
            '<div class="tooltip-p"> Solicitud pendiente <span class="badge badge-pill badge-info" style="position: absolute; margin-top: -10px;"><i class="fas fa-exclamation-circle"></i></span><span class="tooltiptext" style="width: 200px !important">Esta obra tiene un error</span></div>'
          );
          return;
        })
        
    },
  },
  created(){
    this.getOneContractor();
  },
   mounted() {
     
  }       
};

</script>

<style scoped>


div.dataTables_wrapper div.dataTables_filter {
  float: left;
  margin-bottom: 0px;
}
.dataTableBuilder_filter label {
  display: none;
}

div.dataTables_wrapper div.dataTables_filter input {
  position: initial;
  margin-left: 0.5em;
  margin-right: 1rem;
  margin-bottom: 2rem;
  display: inline-block;
  width: 300px ;
  border-radius: 25px ;
  height: 15px ;
  padding-left: 35px ;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  font-family: "OpenSans-Regular" ;
  font-size: 12px ;
  color: #fff;
  background: url('../../../static/zoom_in.png')
    no-repeat scroll 12px 7px #67a3cf ;
  background-size: 20px 20px ;
}

div.dataTables_wrapper div.dataTables_length {
  display: none !important;
}

div.dataTables_wrapper div.dataTables_filter input[search]:focus {
  font-size: 12px;
}

.md-form input[type="search"]:focus:not([readonly]) {
  -webkit-box-shadow: 0 0px 0 0 transparent !important;
  box-shadow: unset;
  border-bottom: unset;
  outline: none !important;
}

div.dataTables_wrapper div.dataTables_filter input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #ffffff !important;
  opacity: 1; /* Firefox */
  font-size: 12px !important;
  padding-left: 0px !important;
  font-family: "OpenSans-Regular" !important;
}

div.dataTables_wrapper div.dataTables_filter input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #ffffff !important;
  font-size: 12px !important;
  padding-left: 0px !important;
  font-family: "OpenSans-Regular" !important;
}

div.dataTables_wrapper div.dataTables_filter input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #ffffff !important;
  font-size: 12px !important;
  padding-left: 0px !important;
  font-family: "OpenSans-Regular" !important;
}

.searchIcon {
  width: 18px;
  height: 18px;
  position: absolute;
  z-index: 999;
  top: 16px;
  left: 26px;
}

.searchIcon img {
  width: 100%;
  height: auto;
}

div.dataTables_wrapper div.dataTables_info {
  padding-top: 8px;
  white-space: nowrap;
  position: absolute;
  top: 60px;
  font-family: "OpenSans-Light" !important;
  display: none !important;
}

.table > thead:first-child > tr:first-child > th {
  border-top: 0;
  font-family: "OpenSans-Semibold" !important;
  color: #747474;
  font-size: 12px;
  text-align: justify;
}

table.dataTable tbody tr {
  background-color: #ffffff !important;
}

.table > thead > tr > th:nth-child(1) > .sorting{
  display: none !important;
}
.table > tbody > tr > td:nth-child(3) {
  text-align: center !important;
}
.table > tbody > tr > td:nth-child(1) {
  text-align: center !important;
}
.table > thead > tr > th:nth-child(3){
  text-align: center !important;
}
.table > thead > tr > th:nth-child(4){
  text-align: center !important;
}

.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 2px solid #f6f6f6;
  font-family: "OpenSans-Regular" !important;
  font-size: 12px;
  color: #000000 !important;
}

.dataTables_wrapper .dataTables_paginate .paginate_button.disabled {
  cursor: default;
  color: #666 !important;
  border-radius: 10px !important;
  background: transparent;
  box-shadow: none;
  font-family: "OpenSans-Light" !important;
  font-size: 12px;
}

.dataTables_wrapper .dataTables_paginate .paginate_button {
  box-sizing: border-box;
  display: inline-block;
  min-width: 1.5em;
  margin-left: 2px;
  text-align: center;
  text-decoration: none !important;
  cursor: pointer;
  color: #333 !important;
  border: 1px solid transparent;
  border-radius: 5px;
  padding: 0px !important;
  margin-left: 14px !important;
}

.pagination > .active > a, 
.pagination > .active > span {
  z-index: 3;
  color: #999;
  cursor: default;
  background-color: #67a3cf !important;
  border-color: #707070 !important;
}
.paginate_button {
  background: #f6f6f6 !important;
}

.dataTables_wrapper .dataTables_paginate {
  width: 600px ;
  float: none ;
  margin: 0 auto ;
}

div.dataTables_paginate {
  display: block ;
  margin-left: auto ;
  margin-right: auto ;
  float: none ;
  text-align: center ;
}

#dataTableBuilder_previous > a,
#dataTableBuilder_next > a {
  height: 30px !important;
}



.tooltip-p {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip-p .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip-p .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip-p:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.fa-custom-icon-notification {
  width: 17px;
  height: 17px;
  background-image: url(https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Notificación.png) !important;
  background-size: 17px 17px !important;
  border: 0px !important;
}
</style>